import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

import { StageStatusLookupComponent } from './stage-status-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [StageStatusLookupComponent],
  exports: [StageStatusLookupComponent],
  providers: []
})
export class StageStatusLookupModule { }
